import { EntryProps, getLogEntryAuthorName, LogEntry } from './logEntry';
import { UserLink } from './userLink/userLink';

export const ConversationOfferTimeout = ({
  entry,
}: EntryProps): JSX.Element => {
  const authorName = getLogEntryAuthorName(entry);
  const authorLink = authorName ? (
    <UserLink userId={entry.author.id}>{authorName}</UserLink>
  ) : null;

  const text = (
    <>Conversation offer is timed out {authorLink && <>for {authorLink}</>}</>
  );

  return <LogEntry entry={entry} text={text} />;
};
